import { fetchWithAuth } from '../../../common/utils/apiUtils';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

export const fetchCertifiers = async () => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/certifiers`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching certifiers:', error);
    throw error;
  }
};

export const fetchCertifierById = async (id) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/certifiers/${id}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching certifier by ID:', error);
    throw error;
  }
};

export const createCertifier = async (certifierData) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/certifiers`, {
      method: 'POST',
      body: JSON.stringify(certifierData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating certifier:', error);
    throw error;
  }
};

export const updateCertifier = async (id, certifierData) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/certifiers/${id}`, {
      method: 'PUT',
      body: JSON.stringify(certifierData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating certifier:', error);
    throw error;
  }
};

export const deleteCertifier = async (id) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/certifiers/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return true;
  } catch (error) {
    console.error('Error deleting certifier:', error);
    throw error;
  }
};